import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  fileUploaderWrapper: {
    position: 'relative',
    display: 'flex',
    '& .MuiInputLabel-root': {
      left: '28px',
      top: '1px',
      '&.MuiInputLabel-shrink': {
        left: '0',
        top: '0'
      }
    },
    '& .MuiOutlinedInput-root': {
      maxHeight: '48px'
    }
  },
  fileName: {
    position: 'absolute',
    top: '13px',
    left: '40px',
    fontFamily: palette.fontFamilies.source,
    fontSize: '18px',
    lineHeight: '24px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '80%',
    pointerEvents: 'none',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  startIcon: {
    position: 'absolute',
    zIndex: '10',
    top: '12px',
    left: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& path': {
      fill: palette.shades[500]
    }
  },
  deleteButton: {
    width: '100%',
    height: '100%',
    maxWidth: '48px',
    marginLeft: '8px',
    border: "1px solid ".concat(palette.shades[500]),
    '&:hover': {
      border: "1px solid ".concat(palette.shades[700])
    }
  },
  startPreviewIcon: {
    position: 'absolute',
    zIndex: '10',
    top: '6px',
    left: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& path': {
      fill: palette.shades[500]
    }
  }
});
export default useStyles;